import { styled } from 'goober';
export var TimelineSlicerWrapper = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        alignItems: 'start',
        gap: '32px',
    });
});
export var TimelineSlicerFirstRow = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
    });
});
export var TimelineSlicerPeriodsContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        alignItems: 'center',
        gap: '4px',
    });
});
export var TimelineSlicerPeriodsSeparator = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        height: '100%',
        width: '2px',
        margin: '2px 8px',
        backgroundColor: theme.colors.neutral.w300,
    });
});
export var TimelineSlicerVersionsContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        alignItems: 'center',
        gap: '4px',
    });
});
